import React from "react";
import { texts } from "../../general/texts";
import colors from "../../colors";
import { Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';

const HowItWorks = () => {

    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery('(max-width:600px)');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1 style={{ color: colors.orange }}>{texts['prompt-how-it-works']}</h1>
            <Card style={{ textAlign: 'start', marginLeft: isSmallScreen ? 0 : '30px', width: isSmallScreen ? '90vw' : '60vw', padding: '15px', borderRadius: '15px' }}>
                <h2 style={{ color: colors.orange }}>{texts['IaF-question-1']}</h2>
                <p style={{ color: colors.darkBlue }}>{texts['IaF-answer-1']}</p>
                <h2 style={{ color: colors.orange }}>{texts['IaF-question-2']}</h2>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-success-1']}</p>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-success-2']}</p>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-success-3.1']} <a href="https://easypay.al/pagesa/" target="_blank" style={{ color: colors.orange }}>pagesa</a> {texts['IaF-success-3.2']}</p>
                <p style={{ color: colors.darkBlue }}>{texts['IaF-success-info']}</p>
                <h2 style={{ color: colors.orange }}>{texts['propmt-details']}</h2>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-details-1']}</p>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-details-2']}</p>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-details-3']}</p>
                <p style={{ color: colors.darkBlue }}>• {texts['IaF-details-4']}</p>
                <p style={{ color: colors.darkBlue }}>{texts['more-info']} <a href="mailto:info@easypay.al" target="_blank" style={{ color: colors.orange }}>easypay.al</a></p>
            </Card>
            <span onClick={() => navigate('/inviteFriend')} style={{ marginTop: '10px', color: colors.orange, fontFamily: 'GerberaBold', cursor: 'pointer' }}>{texts['title-invite-friend']}</span>
        </div>
    )
}
export default HowItWorks;